import { render, staticRenderFns } from "./CompositionsPage.vue?vue&type=template&id=2a448b80&scoped=true"
import script from "./CompositionsPage.vue?vue&type=script&lang=js"
export * from "./CompositionsPage.vue?vue&type=script&lang=js"
import style0 from "./CompositionsPage.vue?vue&type=style&index=0&id=2a448b80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a448b80",
  null
  
)

export default component.exports